import Table from 'components/MantineTable';
import PropTypes from 'prop-types';
import Pagination from 'components/Pagination';
import React, { useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import styles from './styles.module.scss';

const VirtualCoffeeMeetingList = (props) => {
  const { meetingsData = [] } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 10;

  const lastIndex = currentPage * dataPerPage;
  const firstIndex = lastIndex - dataPerPage;

  const formatDate = (dateString) => {
    return moment(dateString, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm');
  };

  const paginatedMeetingsData = meetingsData?.slice(firstIndex, lastIndex).map((item, index) => ({
    id: { value: firstIndex + index, display: false },
    organiser: item.organiser?.email || '',
    guests: item.guests?.map(guest => guest.name || guest.email).join(', ') || '',
    startTime: item.startTime,
    createdAt: item.createdAt
  }));

  const setPage = (number) => {
    setCurrentPage(number);
  };

  return (
    <div className={styles.container}>
      {meetingsData.length === 0 ? (
        <div className={styles.emptyList}>No meetings found</div>
      ) : (
        <>
          <div className={styles.listContainer}>
            <Table
              columns={['ORGANISER', 'GUESTS', 'START TIME', 'CREATED AT']}
              elements={paginatedMeetingsData}
              noHover
            />
            <Pagination
              activePage={currentPage}
              setPage={setPage}
              total={Math.ceil(meetingsData.length / dataPerPage)}
            />
          </div>
        </>
      )}
    </div>
  );
};

VirtualCoffeeMeetingList.propTypes = {
  meetingsData: PropTypes.arrayOf(
    PropTypes.shape({
      guests: PropTypes.arrayOf(
        PropTypes.shape({
          email: PropTypes.string,
          name: PropTypes.string
        })
      ),
      organiser: PropTypes.shape({
        email: PropTypes.string
      }),
      startTime: PropTypes.string,
      endTime: PropTypes.string,
      createdAt: PropTypes.string
    })
  )
};

VirtualCoffeeMeetingList.defaultProps = {
  meetingsData: []
};

export default VirtualCoffeeMeetingList;
